export default class Action {
    static addStep(action, step) {
        if(step == undefined) return
        if(step instanceof Array == false) {
            step = [step]
        }
        step.forEach((step) => {
            action.steps.push(step)
            if(step.omegastage != undefined) {
                action.omegastage = step.omegastage
            }
        })
    }
}
